import React from "react";
import { UtensilsCrossed, Tent, Mountain } from "lucide-react";

const CATEGORY_ICONS = {
  food: UtensilsCrossed,
  stay: Tent,
  adventure: Mountain,
};

function CategoryPicker({ categories, value, onChange }) {
  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((cat) => {
        const Icon = CATEGORY_ICONS[cat];
        return (
          <button
            key={cat}
            type="button"
            onClick={() => onChange(value === cat ? null : cat)}
            className={`flex items-center gap-1.5 px-4 py-2 rounded-xl text-xs font-medium transition-all capitalize ${
              value === cat
                ? "bg-th-accent text-th-bg shadow-md"
                : "bg-th-surface text-th-text-sec border border-th-border hover:border-th-text-sec active:bg-th-card"
            }`}
          >
            {Icon && <Icon size={14} strokeWidth={2} />}
            {cat}
          </button>
        );
      })}
    </div>
  );
}

export default CategoryPicker;
